"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmptyLocalStorageLogStructure = exports.LOCAL_STORAGE_CAMPAIGN_QUESTION_LOG = exports.LOCAL_STORAGE_CAMPAIGNS_QUESTION_LOG_VERSION = exports.INSTRUCTION_VIEWED = void 0;
var INSTRUCTION_VIEWED = exports.INSTRUCTION_VIEWED = 'INSTRUCTION_VIEWED';
var LOCAL_STORAGE_CAMPAIGN_QUESTION_LOG = exports.LOCAL_STORAGE_CAMPAIGN_QUESTION_LOG = 'swipeguide_campaign_log';
var LOCAL_STORAGE_CAMPAIGNS_QUESTION_LOG_VERSION = exports.LOCAL_STORAGE_CAMPAIGNS_QUESTION_LOG_VERSION = '20210622';
var getEmptyLocalStorageLogStructure = exports.getEmptyLocalStorageLogStructure = function getEmptyLocalStorageLogStructure() {
  return {
    campaigns: {
      version: LOCAL_STORAGE_CAMPAIGNS_QUESTION_LOG_VERSION
    }
  };
};
//# sourceMappingURL=campaign-store-constants.js.map